import { changeLanguage, getAppDefaultLanguage } from '@/shared/config/i18n.config';
import {
  USER_PREFERENCE_CLIENT,
  USER_PREFERENCE_PLATFORM
} from '@/shared/constants/user-preference.constants';
import type { CommunicationLanguage } from '@/shared/models/user-preference.model';
import {
  fetchMyPreferences,
  updateMyPreference
} from '@/shared/services/data/user-preference/user-preference.data';
import { getUserAccessToken } from '@/shared/services/helpers/auth-helper/auth-helper.service';
import { resolveLanguageFromPreferences } from '@/shared/utils/user-preference.util';

export async function restoreLanguageAfterLogin(): Promise<CommunicationLanguage> {
  const appDefault = getAppDefaultLanguage();
  const prefs = await fetchMyPreferences();
  const resolved = resolveLanguageFromPreferences(
    prefs,
    USER_PREFERENCE_PLATFORM,
    USER_PREFERENCE_CLIENT,
    appDefault
  );
  changeLanguage(resolved);
  return resolved;
}

export async function restoreLanguageForSession(): Promise<CommunicationLanguage | null> {
  if (!getUserAccessToken()) {
    return null;
  }
  return restoreLanguageAfterLogin();
}

export async function persistLanguagePreference(
  language: CommunicationLanguage
): Promise<boolean> {
  if (!getUserAccessToken()) {
    changeLanguage(language);
    return true;
  }

  changeLanguage(language);
  return updateMyPreference(language);
}
